import React, { Component } from "react";
import { Container, Row, Col, InputGroup, FormControl, Modal, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from "react-select";
import _ from "lodash";

import ModalErrorsDialog from "../../../Modals/ModalErrorsDialog"

import DataService from "../../../../../services/DataService";

import ReceiptLineEditorModel from "./viewModels/ReceiptLineEditorModel.js";
import ProductSearch from "./viewModels/ProductSearch.js";
import ReceiptHeaderModel from "./viewModels/ReceiptHeaderModel";

import Calculator from "./../../../Modals/Calculator/CalcModal/CalculatorModal.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCalculator} from "@fortawesome/free-solid-svg-icons";

export default class AddReceiptLineEditorModal extends Component {

  constructor(props) {
    super(props);

    this.dataService = new DataService("cg");

    this.state = {
      lineEditor: new ReceiptLineEditorModel(),
      productFindStatusColor: "yellow",
      showErrors: false,
      errorBag: {},
      showCalc: false,
      calcValue: 0
    }

    this.poolRef = null;
    this.blockRef = null;
    this.styleRef = null;
    this.sizeRef = null;
    this.labelRef = null;
    this.methodRef = null;
    this.varietyRef = null;
    this.storageRef = null;
    this.regionRef = null;




    this.saveCalcValue = this.saveCalcValue.bind(this);

    this.fetchList = this.fetchList.bind(this);
    this.findProductByAttribs = this.findProductByAttribs.bind(this);
    this.setProductFindStatus = this.setProductFindStatus.bind(this);
    this.refreshItem = this.refreshItem.bind(this);

    this.onPoolSelectChange = this.onPoolSelectChange.bind(this);
    this.onBlockSelectChange = this.onBlockSelectChange.bind(this);
    this.onStyleSelectChange = this.onStyleSelectChange.bind(this);
    this.onSizeSelectChange = this.onSizeSelectChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onEditChange = this.onEditChange.bind(this);

    this.onRequestSaveForm = this.onRequestSaveForm.bind(this);
    this.onRequestCancelForm = this.onRequestCancelForm.bind(this);
    this.onRequestClearForm = this.onRequestClearForm.bind(this);

    this.fillAll = this.fillAll.bind(this);

    this.flushAll = this.flushAll.bind(this);
    this.flushPoolChange = this.flushPoolChange.bind(this);
    this.flushBlockChange = this.flushBlockChange.bind(this);
    this.flushStyleChange = this.flushStyleChange.bind(this);

    this.onRequestErrorsDialogClose = this.onRequestErrorsDialogClose.bind(this);

    this.toggleCalculator = this.toggleCalculator.bind(this);

  }


  async componentDidMount() {
    // pools will be constant. No need to reload them each time.
    await this.dataService.loadCatalogs(this.props.userSession.gcid);
    var openPoolList = this.dataService.fetchOpenPoolOptList(this.props.userSession.locationInfo);
    this.setState({
      poolList: openPoolList
    });
    this.setProductFindStatus();
  }

  componentDidUpdate(prevProps) {
    // did we just 'activate' the dialog? 
    if (prevProps.showLineEditor !== this.props.showLineEditor) {
      if (this.props.showLineEditor) {
        console.log("New: " + this.props.isLineRequestAdd);
        console.log("Last Receipt Line: ");
        console.log(this.props.lastReceiptLine);
        // just turned "on" the dialog
        // we want to "establish" the lineEditor. If this is an "add" then just create a new
        // one. If it's an "edit" then we want to "clone" the currently selected record.
        var myLineEditor;
        if (this.props.isLineRequestAdd) {
          myLineEditor = ((this.props.lastReceiptLine) && (this.props.copyLastLineOnAdd))
            ? _.clone(this.props.lastReceiptLine)
            : new ReceiptLineEditorModel();
          if ((this.props.lastReceiptLine) && (!this.props.lastReceiptLine.isModelEmpty())) {
            //this.fillAll(myLineEditor);
            if (this.props.copyLastLineOnAdd) {
              this.fillAll(myLineEditor);
            } else {
              this.setState({ lineEditor: myLineEditor });
            }
          }
        }
        else {
          // edit
          myLineEditor = _.clone(this.props.currentReceiptLine);
          this.fillAll(myLineEditor);
        }
      }
      this.setState({ lineEditor: myLineEditor });
    }
  }

  toggleCalculator(){
    var currentCalcState = this.state.showCalc;
    var newCalcState = !currentCalcState
    this.setState({
      showCalc: newCalcState
    })
  }


  // return an array of "names" not filled in. A "name" is the value BEFORE Id or Name
  fetchEmptyPropNames(obj, ignoreFields) {
    var result = [];
    Object.keys(obj).forEach(function (key, index) {
      if (!obj[key]) {
        var keyName = key.replace("Id", "").replace("Name", "");
        if (!result.includes(keyName) && (!ignoreFields.includes(keyName))) {
          result.push(keyName);
        }
      }
    });
    return result;
  }


  onRequestErrorsDialogClose() {
    this.setState({ showErrors: false })
  }


  onRequestSaveForm() {
    // validate before saving
    var newLineEditor = this.state.lineEditor;
    newLineEditor.toLotHash();
    console.log("lotHash: " + newLineEditor.lotHash);
    var newErrorBag = {};
    var emptyProps = this.fetchEmptyPropNames(newLineEditor, ["line", "lineNbr", "aggregateLineQty", "diffLineQty", "grade", "lotHash"]);
    if (newLineEditor.lotHash < 0)
    {
      newErrorBag["lotHash"] = {type: "required", message: "lot hash was not calculated."};
      this.setState({
        showErrors: true,
        errorBag: newErrorBag
      });
      return;
    }
    
    if (emptyProps.length > 0) {
      var msg = "Unable to save. The following properties must be selected: " + emptyProps.join(", ");

      for (var i = 0; i < emptyProps.length; i++) {
        msg = (emptyProps[i] === "item") ? "Unable to find an item with this combination of attributes" : emptyProps[i] + " is required.";
        newErrorBag[emptyProps[i]] = { type: "required", message: msg };
      }
      this.setState({
        showErrors: true,
        errorBag: newErrorBag
      });
      return;
    }

    var lineWithLotAlreadyExits = (this.props.existingReceiptLines.some(erl => {
      console.log("This hashLot: " + newLineEditor.lotHash);
      console.log("existing hashLot: " + erl.lotHash);
      return (erl.lotHash === newLineEditor.lotHash)
    }));
    if (lineWithLotAlreadyExits && this.props.isLineRequestAdd) {
      console.log("Lot Already Exists!");
      newErrorBag["identicalLot"] = { type: "lotexists", message: "Unable to save. You already have a line with this combination of attributes." };
      this.setState({
        showErrors: true,
        errorBag: newErrorBag
      });
      return;
    }



    if (this.props.isLineRequestAdd) {
      this.props.onAddReceiptLine(newLineEditor);
    } else {
      this.props.onUpdateReceiptLine(newLineEditor);
    }
    this.flushAll();
    this.props.onRequestLineEditorDialogClose();
  }

  onRequestCancelForm() {
    this.flushAll();
    this.props.onRequestLineEditorDialogClose();
  }

  onRequestClearForm() {
    this.flushAll();
  }


  fillAll(lineEditor) {
    //this.poolRef.setValue(lineEditor.poolId);
    var myCommodity = this.dataService.fetchCommodity(lineEditor.commodityId);
    var newBlockList = this.dataService.fetchOpenBlockOptList(lineEditor.poolId, this.props.userSession.locationInfo);
    var newStyleList = this.dataService.fetchCatAttribOptList(myCommodity, "stylesCatalog", "style");
    var myStyle = this.dataService.fetchStyle(lineEditor.commodityId, lineEditor.styleId);
    var newSizeList = this.dataService.fetchCatAttribOptList(myStyle, "sizesCatalog", "size");
    var newLabelList = this.dataService.fetchCommodityAttribOptList(lineEditor.commodityId, "labels");
    var newMethodList = this.dataService.fetchCommodityAttribOptList(lineEditor.commodityId, "methods");
    var newVarietyList = this.dataService.fetchCommodityAttribOptList(lineEditor.commodityId, "colors");
    var newStorageList = this.dataService.fetchCommodityAttribOptList(lineEditor.commodityId, "storages");
    var newRegionList = this.dataService.fetchCommodityAttribOptList(lineEditor.commodityId, "regions");

    this.setState({
      lineEditor: lineEditor,
      blockList: newBlockList,
      styleList: newStyleList,
      sizeList: newSizeList,
      labelList: newLabelList,
      methodList: newMethodList,
      varietyList: newVarietyList,
      storageList: newStorageList,
      regionList: newRegionList
    });

  }


  flushAll() {
    this.setState({ lineEditor: new ReceiptLineEditorModel() });
    this.poolRef.select.clearValue();
    // TBD: poolName should be cleared
    this.flushPoolChange();
    this.setProductFindStatus();
  }

  flushPoolChange() {
    this.setState({
      styleList: this.fetchEmptyList(),
      labelList: this.fetchEmptyList(),
      methodList: this.fetchEmptyList(),
      varietyList: this.fetchEmptyList(),
      storageList: this.fetchEmptyList(),
      regionList: this.fetchEmptyList(),
      sizeList: this.fetchEmptyList()
    })
    this.blockRef.select.clearValue();
    // TBD - blockname should be cleared
    this.flushBlockChange(); // do NOT set the style lists
    this.setProductFindStatus();
  }


  flushBlockChange(myBlock) {
    if (myBlock) {
      console.log("My Block: ");
      console.info(myBlock);
      console.log("My Block Commodity Id: " + myBlock.commodity.id);
      var newStyleList = this.dataService.fetchCommodityAttribOptListFromCat(myBlock.commodity.id, "stylesCatalog", "style");
      var newLabelList = this.dataService.fetchCommodityAttribOptList(myBlock.commodity.id, "labels");
      var newMethodList = this.dataService.fetchCommodityAttribOptList(myBlock.commodity.id, "methods");
      var newVarietyList = this.dataService.fetchCommodityAttribOptList(myBlock.commodity.id, "colors");
      var newStorageList = this.dataService.fetchCommodityAttribOptList(myBlock.commodity.id, "storages");
      var newRegionList = this.dataService.fetchCommodityAttribOptList(myBlock.commodity.id, "regions");
      this.setState({
        itemId: "",
        itemName: "",
        uomId: "",
        uomName: "",
        itemPalletDefaultCubeQty: "",
        styleList: newStyleList,
        labelList: newLabelList,
        methodList: newMethodList,
        varietyList: newVarietyList,
        storageList: newStorageList,
        regionList: newRegionList,
        sizeList: this.fetchEmptyList()
      });
    }
    this.styleRef.select.clearValue();
    this.sizeRef.select.clearValue();
    this.labelRef.select.clearValue();
    this.methodRef.select.clearValue();
    this.varietyRef.select.clearValue();
    this.storageRef.select.clearValue();
    this.regionRef.select.clearValue();
    this.flushStyleChange();
    this.setProductFindStatus();
  }

  flushStyleChange(myStyle) {
    if (myStyle) {
      var newSizeList = this.dataService.fetchCatAttribOptList(myStyle, "sizesCatalog", "size");
      //var newSizeList = this.toOptList(myStyle.sizesCatalog, "size"); // convert 
      this.setState({ sizeList: newSizeList });
    }
    this.sizeRef.select.clearValue();
    this.setProductFindStatus();
  }


  findProductByAttribs(lineEditor) {

    var prodSearch = new ProductSearch(lineEditor.commodityId, lineEditor.regionId, lineEditor.methodId, lineEditor.styleId, lineEditor.labelId, lineEditor.sizeId);
    var product = this.dataService.fetchProduct(prodSearch);
    return product;
  }

  setProductFindStatus() {
    var newStatusColor = "lightgreen";
    var lineEditor = this.state.lineEditor;
    if ((!lineEditor) || (!lineEditor.itemId)) {
      // are ALL product statuses filled in? If so, then show red. otherwise, yellow. 
      var prodSearch = new ProductSearch(lineEditor.commodityId, lineEditor.regionId, lineEditor.methodId, lineEditor.styleId, lineEditor.labelId, lineEditor.sizeId);
      newStatusColor = (prodSearch.isValid()) ? "red" : "yellow";


    }
    this.setState({ productFindStatusColor: newStatusColor });
    //console.log("new item status color: " + newStatusColor);
  }


  refreshItem(myLineEditor) {
    var item = this.findProductByAttribs(myLineEditor);
    //console.log("actionName: " + action.name);
    //console.log("Line Editor for find: ");
    //console.log(myLineEditor);
    if (item) {
      myLineEditor.itemId = item.product.id;
      myLineEditor.itemName = item.product.name;
      var unitsPerPalletString = this.dataService.fetchExtraProp(item.size, "UnitsPerPallet").value;
      myLineEditor.itemPalletDefaultCubeQty = parseInt(unitsPerPalletString);
      // assign grower
      var block = this.dataService.fetchBlock(myLineEditor.poolId, myLineEditor.blockId);
      myLineEditor.growerId = block.grower.erpId;
      myLineEditor.growerName = block.grower.name;
      myLineEditor.growerNbr = block.grower.id;
    }
    else {
      myLineEditor.itemId = "";
      myLineEditor.itemName = "";
      myLineEditor.itemPalletDefaultCubeQty = 0;
    }
    this.setState({ lineEditor: myLineEditor });
    this.setProductFindStatus();
  }

  onEditChange(ev) {
    console.log("on edit change")

    var myLineEditor = this.state.lineEditor || new ReceiptLineEditorModel();
    myLineEditor[ev.target.id] = ev.target.value;
    var item = this.findProductByAttribs(myLineEditor);
    console.log(item)
    this.setState({ lineEditor: myLineEditor });
  }


  onPoolSelectChange(inputValue, action) {
    if (!inputValue) return;
    var myLineEditor = this.state.lineEditor || new ReceiptLineEditorModel();
    myLineEditor.flushLineProps();
    myLineEditor.poolId = inputValue.value;
    myLineEditor.poolName = inputValue.label;
    myLineEditor.regionId = this.props.userSession.locationInfo.auxInfo.regionId;
    myLineEditor.regionName = this.props.userSession.locationInfo.auxInfo.regionName;
    // now we can "ungate" the block list
    var newBlockList = this.dataService.fetchOpenBlockOptList(inputValue.value, this.props.userSession.locationInfo);
    this.setState({
      lineEditor: myLineEditor,
      blockList: newBlockList
    });
    this.flushPoolChange();
    this.forceUpdate();
  }

  onBlockSelectChange(inputValue, action) {
    if (!inputValue) return;
    var myLineEditor = this.state.lineEditor || new ReceiptLineEditorModel();
    myLineEditor.blockId = inputValue.value;
    myLineEditor.blockName = inputValue.label;
    myLineEditor.styleId = "";
    myLineEditor.styleName = "";
    // now that we know the block, we know the commodity, which ungates most of our lookups
    var myBlock = this.dataService.fetchBlock(this.state.lineEditor.poolId, inputValue.value);
    myLineEditor.commodityId = myBlock.commodity.id;
    myLineEditor.commodityName = myBlock.commodity.name;
    var grower = myBlock.grower;
    myLineEditor.growerId = grower.erpId;
    myLineEditor.growerName = grower.name;
    myLineEditor.growerNbr = grower.id;
    this.setState({
      lineEditor: myLineEditor,
    });
    this.flushBlockChange(myBlock);
    this.forceUpdate();
  }

  onStyleSelectChange(inputValue, action) {
    if (!inputValue) return;
    var myLineEditor = this.state.lineEditor || new ReceiptLineEditorModel();
    myLineEditor.styleId = inputValue.value || "";
    myLineEditor.styleName = inputValue.label || "";
    myLineEditor.sizeId = "";
    myLineEditor.sizeName = "";
    myLineEditor.uomId = "";
    myLineEditor.uomName = "";
    myLineEditor.itemPalletDefaultCubeQty = 0;
    // now find the style, which unlocks a bunch of stuff
    var myStyle = this.dataService.fetchStyle(myLineEditor.commodityId, inputValue.value);
    this.setState({
      lineEditor: myLineEditor
    });
    this.flushStyleChange(myStyle);
    this.refreshItem(myLineEditor);
  }

  onSizeSelectChange(inputValue, action) {
    if (!inputValue) return;
    var myLineEditor = this.state.lineEditor || new ReceiptLineEditorModel();
    myLineEditor.sizeId = inputValue.value;
    myLineEditor.sizeName = inputValue.label;
    // now find the style, which unlocks a bunch of stuff
    var mySize = this.dataService.fetchSize(myLineEditor.commodityId, myLineEditor.styleId, inputValue.value);
    // assumes there is only a single unit of measure
    myLineEditor.uomId = mySize.uoms[0].id;
    myLineEditor.uomName = mySize.uoms[0].name;
    myLineEditor.itemPalletDefaultCubeQty = this.dataService.fetchExtraProp(mySize.size, "UnitsPerPallet").value;

    this.setState({
      lineEditor: myLineEditor
    })
    this.refreshItem(myLineEditor);
  }





  onSelectChange(inputValue, action) {
    if (!inputValue) return;
    var myLineEditor = this.state.lineEditor || new ReceiptLineEditorModel();
    // NOTE the convention! the "ref" or "root" has an "Id" and a "Name". The action seems to be set to the Id
    myLineEditor[action.name] = inputValue.value;
    myLineEditor[action.name.replace("Id", "") + "Name"] = inputValue.label;
    //var item = this.findProductByAttribs(myLineEditor);
    //console.log("actionName: " + action.name);
    //console.log("Line Editor for find: ");
    //console.log(myLineEditor);
    this.refreshItem(myLineEditor);

  }


  makeInputGroup(id, labelText, defaultValue, placeholder, readOnly = true, bkgColor) {
    var shouldFocus = true;
    var inputType = typeof (defaultValue);
    var Calc = <span/>
    if (id === "tagLineQty") {
      shouldFocus = true
      inputType = "number"
      Calc = <Button onClick={this.toggleCalculator}><FontAwesomeIcon icon={faCalculator}/></Button>
    } else {
      shouldFocus = false
      inputType = "text"
    }

    return (
      <span>
        <label>{labelText}</label>
        <InputGroup>
          <FormControl
            style={(bkgColor) ?
              { backgroundColor: this.state.productFindStatusColor } :
              { backgroundColor: "lightgrey" }
            }
            autoFocus={shouldFocus}
            type={inputType}
            readOnly={readOnly}
            id={id} value={defaultValue}
            placeholder={(placeholder ? placeholder : defaultValue)}
            onChange={this.onEditChange} />
            {Calc}
        </InputGroup>
      </span>
    )
  }

  fetchEmptyList(msg) {
    var result = [{ "value": "", "label": "" }];
    return result;
  }


  fetchList(listType) {
    return this.state.lookupDictionary.reduce(function (result, lk) {
      if (lk.listType === listType) {
        result.push({ "value": lk.value, "label": lk.label })
      }
      return result;
    }, []);
  }


  makeSelectOptGroup(ref, id, labelText, opts, currentValue, selectChange) {

    const opt = opts || this.fetchEmptyList(labelText);
    var selectRef = ref + "Ref";

    return (
      <span>
        <label>{labelText}</label>
        <Select
          ref={ref => {
            this[selectRef] = ref;
          }}
          className="basic-single"
          classNamePrefix="select"
          placeholder={labelText}
          //defaultValue={currentValue}
          value={(opts) ? opts.find(opt => opt.value === currentValue) : ""}
          isClearable={true}
          isRtl={false}
          isSearchable={true}
          name={id}
          options={opt}
          onChange={selectChange || this.onSelectChange}
        />
      </span>
    )
  }

  saveCalcValue(newVal){

    var fakeEv = {
    target: {
      id: "tagLineQty",
      value: newVal
    }
  }

    this.onEditChange(fakeEv)
  }



  render() {

    const editorValues = (this.state.lineEditor) ? this.state.lineEditor : new ReceiptLineEditorModel();

    return (

      <Modal
        show={this.props.showLineEditor}
        onHide={this.props.onRequestLineEditorDialogClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Receipt Line Editor</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <ModalErrorsDialog
            title={"Cannot Save"}
            show={this.state.showErrors}
            errorBag={this.state.errorBag}
            onRequestErrorsDialogClose={this.onRequestErrorsDialogClose}
          />
          
          <Calculator
            saveCalcValue={this.saveCalcValue}
            show={this.state.showCalc}
            onHide={this.toggleCalculator}
          />

          <Container>
            <Row>
              <Col>{this.makeInputGroup("tagLineQty", "Line Qty", editorValues.tagLineQty, editorValues.tagLineQty, false, "white")}</Col>
              <Col>{this.makeSelectOptGroup("pool", "poolId", "Pool Id", this.state.poolList, editorValues.poolId, this.onPoolSelectChange)}</Col>
            </Row>
            <Row>
              <Col>{this.makeInputGroup("poolName", "Pool Description", editorValues.poolName)}</Col>
            </Row>
            <Row>
              <Col>{this.makeSelectOptGroup("block", "blockId", "Block Id", this.state.blockList, editorValues.blockId, this.onBlockSelectChange)}</Col>
              <Col>{this.makeInputGroup("blockName", "Block Name", editorValues.blockName)}</Col>
            </Row>
            <Row>
              <Col>{this.makeInputGroup("growerId", "Grower Id", editorValues.growerId)}</Col>
              <Col>{this.makeInputGroup("growerNbr", "Grower Nbr", editorValues.growerNbr)}</Col>
              <Col>{this.makeInputGroup("growerName", "Grower Name", editorValues.growerName)}</Col>
            </Row>
            <Row>
              <Col>{this.makeInputGroup("commodity", "Commodity", editorValues.commodityName)}</Col>
              <Col>{this.makeSelectOptGroup("region", "regionId", "Region", this.state.regionList, editorValues.regionId)}</Col>
            </Row>
            <Row>
              <Col>{this.makeSelectOptGroup("style", "styleId", "Style", this.state.styleList, editorValues.styleId, this.onStyleSelectChange)}</Col>
              <Col>{this.makeSelectOptGroup("size", "sizeId", "Size", this.state.sizeList, editorValues.sizeId, this.onSizeSelectChange)}</Col>
            </Row>
            <Row>
              <Col>{this.makeSelectOptGroup("label", "labelId", "Label", this.state.labelList, editorValues.labelId)}</Col>
              <Col>{this.makeSelectOptGroup("method", "methodId", "Method", this.state.methodList, editorValues.methodId)}</Col>
            </Row>
            <Row>
              <Col>{this.makeSelectOptGroup("variety", "varietyId", "Variety", this.state.varietyList, editorValues.varietyId)}</Col>
              <Col>{this.makeSelectOptGroup("storage", "storageId", "Storage", this.state.storageList, editorValues.storageId)}</Col>
            </Row>
            <Row>
              <Col>{this.makeInputGroup("uom", "UOM", editorValues.uomName)}</Col>
              <Col>{this.makeInputGroup("itemPalletDefaultCubeQty", "Default Pallet Qty", editorValues.itemPalletDefaultCubeQty)}</Col>
            </Row>
            <Row>

              <Col>{this.makeInputGroup("itemName", "Item Name", editorValues.itemName, "No Item Found", true, this.state.productFindStatusColor)}</Col>
            </Row>

          </Container>
        </Modal.Body>
        <Modal.Footer style={{ padding: "0" }}>
          <Button
            variant="secondary"
            onClick={this.onRequestSaveForm}
          >
            Save
          </Button>
          <Button
            variant="secondary"
            onClick={this.onRequestCancelForm}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            onClick={this.onRequestClearForm}
          >
            Clear
          </Button>
        </Modal.Footer>
      </Modal>



    );
  }



}